import { render, staticRenderFns } from "./viewstaff.vue?vue&type=template&id=27fc8bae&"
import script from "./viewstaff.vue?vue&type=script&lang=js&"
export * from "./viewstaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports